import m from '@bitstillery/mithril'
import {MithrilComponent} from '@bitstillery/mithril'
import {classes} from '@bitstillery/common/lib/utils'
import {cycle_mode, get_mode, type ThemeMode} from '@bitstillery/common/lib/theme'

import {Icon} from '../icon/icon'

/**
 * Single-button 3-state theme toggle: click cycles light → dark → auto, showing the active mode's icon.
 * Shared across portal / discover / sandbox; pass `className` to blend into the host bar.
 */
const ICON: Record<ThemeMode, string> = {light: 'sun', dark: 'moon', auto: 'themeAuto'}
const LABEL: Record<ThemeMode, string> = {light: 'Light theme', dark: 'Dark theme', auto: 'System theme'}

interface ThemeSwitcherAttrs {
    className?: string
    size?: 'xs' | 's' | 'd' | 'l' | 'xl' | 'xxl' | 'xxxl'
    type?: string
}

export class ThemeSwitcher extends MithrilComponent<ThemeSwitcherAttrs> {
    view(vn: m.Vnode<ThemeSwitcherAttrs>) {
        const mode = get_mode()
        return (
            <div
                className={classes('c-theme-switcher', vn.attrs.className)}
                onclick={() => {
                    cycle_mode()
                    m.redraw()
                }}
                title={LABEL[mode]}
            >
                <Icon name={ICON[mode]} size={vn.attrs.size ?? 'l'} type={vn.attrs.type ?? 'info'} />
            </div>
        )
    }
}
